var map = {
	"./BatchUpdates": 95,
	"./BatchUpdates.jsx": 95,
	"./CarrierServices": 94,
	"./CarrierServices.jsx": 94,
	"./InventoryScanApp": 135,
	"./InventoryScanApp.jsx": 135,
	"./LoadingButton": 61,
	"./LoadingButton.jsx": 61,
	"./MediaUpload": 93,
	"./MediaUpload.jsx": 93,
	"./OrderItem": 89,
	"./OrderItem.jsx": 89,
	"./OrderPage": 144,
	"./OrderPage.jsx": 144,
	"./OrdersPage": 171,
	"./OrdersPage.jsx": 171,
	"./PickupPrice": 121,
	"./PickupPrice.jsx": 121,
	"./Redirect": 165,
	"./Redirect.jsx": 165,
	"./SettingsPage": 166,
	"./SettingsPage.jsx": 166,
	"./StickersPage": 167,
	"./StickersPage.jsx": 167,
	"./StockReleasePage": 168,
	"./StockReleasePage.jsx": 168,
	"./UploadPage": 169,
	"./UploadPage.jsx": 169,
	"./showroom/ConfirmForm": 92,
	"./showroom/ConfirmForm.jsx": 92,
	"./showroom/ConfirmFormSelect": 76,
	"./showroom/ConfirmFormSelect.jsx": 76,
	"./showroom/SampleScanApp": 172,
	"./showroom/SampleScanApp.jsx": 172,
	"./stock_release/SendStockAlerts": 90,
	"./stock_release/SendStockAlerts.jsx": 90,
	"./stock_release/SyncKlaviyoFeed": 91,
	"./stock_release/SyncKlaviyoFeed.jsx": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;